import { message } from "antd";
import { baseRequest } from "../../util/Api";
import { v4 } from "uuid";


export const getShortLinks = () => {
  return new Promise((resolve, reject) => {
    baseRequest("get", "/shortlinks")
      .then((data) => {
        resolve(data)
      }).catch((e) => {
        reject(e)
      })
  })
}

export const saveNewShortLink = (data) => {
  return new Promise((resolve) => {
    const key = v4();
    message.open({ key, type: 'loading', content: "Menambah short link ..." })
    baseRequest("post", "/shortlinks/", null, data)
      .then((newData) => {
        message.success({ key, type: 'success', content: "Menambah short link berhasil" })
        resolve(newData);
      })
      .catch((e) => {
        message.error({ key, type: 'error', content: e })
      });
  });
}

export const updateShortLink = (data, id) => {
  return new Promise((resolve) => {
    const key = v4();
    message.open({ key, type: 'loading', content: "Mengedit short link ..." })
    baseRequest("put", "/shortlinks/" + id, null, data)
      .then((newData) => {
        message.success({ key, type: 'success', content: "Mengedit short link berhasil" })
        resolve(newData);
      })
      .catch((e) => {
        message.error({ key, type: 'error', content: e })
      });
  });
}

export const getShortLink = (id) => {
  return new Promise((resolve, reject) => {
    baseRequest("get", "/shortlinks/" + id)
      .then((data) => {
        resolve(data)
      }).catch((e) => {
        reject(e)
      })
  })
}


export const getShortLinkByCode = (code) => {
  return new Promise((resolve, reject) => {
    baseRequest("get", "/shortlinks/url/" + code)
      .then((data) => {
        resolve(data)
      }).catch((e) => {
        reject(e)
      })
  })
}

export const deleteShortLink = (id) => {
  return new Promise((resolve, reject) => {
    const key = v4()
    message.open({ key, type: 'loading', content: "Menghapus short link ..." })
    baseRequest("delete", "/shortlinks/" + id)
      .then((data) => {
        message.success({ key, type: 'success', content: "Menghapus short link berhasil" })
        resolve(data)
      }).catch((e) => {
        reject(e)
      })
  })
}
